import React, { Fragment, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { ApolloProvider } from 'react-apollo';
import { useInView } from 'react-intersection-observer';
import CommunitiesProvider from '../../context/CommunitiesContext';
import CommunitiesSlider from './CommunitiesSlider';
import CommunitiesModal from './CommunitiesModal';
import { client } from '../client';

function WrappedCommunitiesWrapper() {
  // Using portals to connect the two components state via CommunitiesProvider
  const sliderPortal = document.querySelector('#communities-slider-portal');
  const modalPortal = document.querySelector('#communities-modal-portal');

  return (
    <Fragment>
      {sliderPortal &&
        ReactDOM.createPortal(<CommunitiesSlider />, sliderPortal)}
      {modalPortal && ReactDOM.createPortal(<CommunitiesModal />, modalPortal)}
    </Fragment>
  );
}

export default function CommunitiesWrapper({ city }) {
  const [renderCommunities, setRenderCommunities] = useState(false);

  const [nearbyRentalsRef, inView] = useInView({
    threshold: 0,
  });

  useEffect(() => {
    if (!renderCommunities && inView) setRenderCommunities(true);
  }, [inView, renderCommunities]);

  return (
    <div ref={nearbyRentalsRef}>
      <ApolloProvider client={client}>
        {renderCommunities && (
          <CommunitiesProvider city={city}>
            <WrappedCommunitiesWrapper />
          </CommunitiesProvider>
        )}
      </ApolloProvider>
    </div>
  );
}

CommunitiesWrapper.propTypes = {
  city: PropTypes.string.isRequired,
};
